import { render } from "./RolesComponent.vue?vue&type=template&id=6aacd86a"
import script from "./RolesComponent.vue?vue&type=script&lang=js"
export * from "./RolesComponent.vue?vue&type=script&lang=js"

import "./RolesComponent.vue?vue&type=style&index=0&id=6aacd86a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__